import React from "react";
import { useNavigate } from "react-router-dom";
import { tabs } from "./utils";

const FirmwareBundlesButtons = ({
  className = "dropdown-item",
  releases = [],
  oblacDrivesVersion,
  firmwareVersion,
}) => {
  const navigate = useNavigate();

  if (!releases || releases.length === 0) return null;

  const selectedRelease =
    releases.find((r) => r.version === oblacDrivesVersion) || releases[0];
  const resolvedOblacDrivesVersion = selectedRelease?.version || "latest";

  const rawFirmwareVersion =
    firmwareVersion ||
    (selectedRelease?.firmwares && selectedRelease.firmwares.length > 0
      ? typeof selectedRelease.firmwares[0] === "string"
        ? selectedRelease.firmwares[0]
        : selectedRelease.firmwares[0].version
      : "latest");

  const resolvedFirmwareVersion = rawFirmwareVersion.startsWith("v")
    ? rawFirmwareVersion.slice(1)
    : rawFirmwareVersion;

  const handleNavigate = (tab) => {
    navigate(
      `/${resolvedOblacDrivesVersion}/${resolvedFirmwareVersion}/${tab}`,
    );
  };

  return (
    <>
      {tabs.map(({ key, label }) => (
        <button
          key={key}
          onClick={() => handleNavigate(key)}
          className={className}
        >
          {label}
        </button>
      ))}
    </>
  );
};

export default FirmwareBundlesButtons;
